"use strict"
var inherits = require('util').inherits
var Writable = require('stream').Writable

function ConnectionGraph (graphOptions) {
  if (!(this instanceof ConnectionGraph)) {
    return new ConnectionGraph(graphOptions)
  }
  Writable.call(this, {objectMode: true})
  this.counterTypes = graphOptions.counterTypes
  this.stackBy = graphOptions.stackBy || 'none'

  this.latestValue = {}
}
inherits(ConnectionGraph, Writable)

var proto = ConnectionGraph.prototype

proto._write = function (data, enc, next) {
  this.latestValue = data
  next()
}

proto.getGraphData = function () {
  return this.latestValue
}

proto.destroy = function () {
  if (this.destroyed) { return }
  this.destroyed = true
}

module.exports = ConnectionGraph
